const CharCodes = {}

for (const str of ['\n', '\r', ' ', ':']) {
  CharCodes[str] = str.charCodeAt(0)
}

export default CharCodes
